import { ReactElement } from 'react'

import Meta from '@/components/base/meta'
import Layout from '@/components/layout/layout'
import SearchPage from '@/components/layout/search'

import { WPPageData } from '@/types'

export default function Search() {
  return <SearchPage className="relative z-search" />
}

Search.getLayout = function getLayout(page: ReactElement, pageProps: WPPageData) {
  return (
    <Layout pageProps={pageProps}>
      <Meta pageProps={pageProps} />
      {page}
    </Layout>
  )
}

export async function getStaticProps() {
  const pageProps = require(`@/data/pages/search.json`)

  return {
    props: {
      ...pageProps
    }
  }
}
